<template>
  <div class="row">
    <!-- BREADCRUMB -->
    <div class="col-md-12">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'informes' }">{{
              $t("informes")
            }}</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ $t("pedidosGuionPasarelaDePago") }}
          </li>
        </ol>
      </nav>
    </div>

    <CabeceraInformes
      :listBusinesses="listBusinesses"
      :listTpv="listTpv"
      :idBusiness="idBusiness"
      :idTpv="idTpv"
      :dateto="dateto"
      :datefrom="datefrom"
      :conTodos="false"
    />
    <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
    </template>
    <!-- LISTA -->
    <template v-else-if="list.length > 0">
      <div class="table-responsive col-md-12">
        <table class="table table-bordered table-striped text-nowrap">
          <thead class="thead-dark">
            <tr>
              <th @click="sortResult('dia', ordenarDia)">
                <i
                  v-if="ordenarDia"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>
                {{ $t("dia") }}
              </th>
              <th @click="sortResult('total', ordenarTotal)">
                <i
                  v-if="ordenarTotal"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>
                {{ $t("totalVenta") }}
              </th>
              <th
                @click="sortResult('numpedido', ordenarNumPedido)"
                class="text-right"
              >
                <i
                  v-if="ordenarNumPedido"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>

                {{ $t("numPedidos") }}
              </th>
              <th class="text-right" @click="sortResult('total', ordenarTotal)">
                <i
                  v-if="ordenarTotal"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>
                {{ $t("comision") }} %
              </th>
              <th
                class="text-right"
                @click="sortResult('numpedido', ordenarNumPedido)"
              >
                <i
                  v-if="ordenarNumPedido"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>
                {{ $t("costoPorPedido") }}
              </th>
              <th
                class="text-right"
                @click="sortResult('totalComisiones', ordenarTotalComisiones)"
              >
                <i
                  v-if="ordenarTotalComisiones"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>
                {{ $t("totalComisiones") }}
              </th>
              <th
                class="text-right"
                @click="
                  sortResult('totalSinComisiones', ordenarTotalSinComisiones)
                "
              >
                <i
                  v-if="ordenarTotalSinComisiones"
                  style="color: white"
                  class="fa fa-angle-up"
                ></i>
                <i v-else style="color: white" class="fa fa-angle-down"></i>
                {{ $t("totalSinComisiones") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="obj in list">
              <td :class="getClassDay(obj.dia)">
                {{ obj.dia | getDiaSemana | getInitDia }}
                {{ obj.dia }}
              </td>
              <td class="table-success" align="right">
                {{ obj.total | currency }}
              </td>
              <td align="right">{{ obj.numPedidos }}</td>
              <td align="right">{{ comisionPorc(obj) | currency }}</td>
              <td align="right">{{ costoPorPedido(obj) | currency }}</td>
              <td class="table-danger" align="right">
                {{ totalComision(obj) | currency }}
              </td>
              <td class="table-success" align="right">
                {{ totalSinComision(obj) | currency }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="table-success">
                <strong>{{ $t("total") }}:</strong>
              </td>
              <td class="text-right table-success">
                {{ getTotalFormaPago | currency }}
              </td>

              <td class="text-right">
                {{ getTotalNumPedidos }}
              </td>
              <td class="text-right">{{ getComisionPorc | currency }}</td>
              <td class="text-right">
                {{ getTotalCostoPorPedido | currency }}
              </td>
              <td class="text-right table-danger">
                {{ getTotalComision | currency }}
              </td>
              <td class="text-right table-success">
                {{ getTotalSinComision | currency }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="col-md-12">
        <div class="alert alert-danger" role="alert">
          {{ $t("noHayVentasDeProductosEnEsteRangoDeFechas") }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
import bus from "../../../../bus";
import { Loading } from "element-ui";
import { mapState } from 'vuex'

export default {
  components: {
    CabeceraInformes,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      list: [],
      stripedata: null,
      $Chart: null,
      listTpv: [],
      idTpv: 0,
      reseteado: true,

      listCheckBoxTpv: [],
      idsTPV: [],

      //ORDENAR
      ordenarDia: true,
      ordenarTotal: true,
      ordenarNumPedido: true,
      ordenarTotalSinComisiones: true,
      ordenarTotalComisiones: true,

      respuesta: true,
      getTotalNumPedidos: 0,
      getTotalCostoPorPedido: 0,
      getTotalFormaPago: 0,
      getTotalComision: 0,
      getTotalSinComision: 0,
      getComisionPorc: 0,
    };
  },

  watch: {
    list: function() {
      this.getTotalNumPedidos = 0;
      this.getTotalCostoPorPedido = 0;
      this.getTotalFormaPago = 0;
      this.getTotalComision = 0;
      this.getTotalSinComision = 0;
      this.getComisionPorc = 0;
      if (this.list && this.list.length > 0) {
        this.list.forEach((el) => {
          this.getTotalNumPedidos += el.numPedidos;
          this.getTotalFormaPago += el.total;
          this.getTotalCostoPorPedido += parseFloat(this.costoPorPedido(el));
          this.getTotalComision += this.totalComision(el);
          this.getTotalSinComision += parseFloat(this.totalSinComision(el));
          this.getComisionPorc += parseFloat(this.comisionPorc(el));
        });
      }
    },
  },
  computed: {
    ...mapState(["permiso"]),
  },

  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", "Pedidos - Pasarela de pago");
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }

    //this.getVentasPorFormasDePago();
  },
  methods: {
    getClassDay(date) {
      var classDay = "";
      if (typeof date == "string") {
        const Edate = date.split("-");
        date = new Date(Edate[2], Edate[1] - 1, Edate[0]);
      }
      var humanDate = moment.unix(Math.floor(date / 1000));
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },

    comisionPorc(data) {
      return (parseFloat(data.total) * this.stripedata.comision * 0.01).toFixed(
        2
      );
    },
    totalComision(data) {
      return (
        parseFloat(this.comisionPorc(data)) +
        parseFloat(this.costoPorPedido(data))
      );
    },
    costoPorPedido(data) {
      let result = 0;
      if (data.numPedidos) {
        result = this.stripedata.comision_importe * data.numPedidos;
      }
      return result.toFixed(2);
    },
    totalSinComision(data) {
      const total = parseFloat(data.total);
      return (total - this.totalComision(data)).toFixed(2);
    },
    sortResult(columna, orden) {
      const vm = this;
      if (this.list) {
        switch (columna) {
          case "dia":
            this.ordenarDia = !this.ordenarDia;
            this.list.sort((a, b) => {
              if (a.dia > b.dia) {
                return vm.ordenarDia ? 1 : -1;
              } else if (a.dia < b.dia) {
                return vm.ordenarDia ? -1 : 1;
              } else {
                return 0;
              }
            });
            break;
          case "total":
            this.ordenarTotal = !this.ordenarTotal;
            this.list.sort((a, b) => {
              if (a.total > b.total) {
                return vm.ordenarTotal ? 1 : -1;
              } else if (a.total < b.total) {
                return vm.ordenarTotal ? -1 : 1;
              } else {
                return 0;
              }
            });
            break;
          case "numpedido":
            this.ordenarNumPedido = !this.ordenarNumPedido;
            this.list.sort((a, b) => {
              if (a.numPedidos > b.numPedidos) {
                return vm.ordenarNumPedido ? 1 : -1;
              } else if (a.numPedidos < b.numPedidos) {
                return vm.ordenarNumPedido ? -1 : 1;
              } else {
                return 0;
              }
            });
            break;
          case "totalComisiones":
            this.ordenarTotalComisiones = !this.ordenarTotalComisiones;
            this.list.sort((a, b) => {
              if (
                parseFloat(this.totalComision(a)) >
                parseFloat(this.totalComision(b))
              ) {
                return vm.ordenarTotalComisiones ? 1 : -1;
              } else if (
                parseFloat(this.totalComision(a)) <
                parseFloat(this.totalComision(b))
              ) {
                return vm.ordenarTotalComisiones ? -1 : 1;
              } else {
                return 0;
              }
            });
            break;
          case "totalSinComisiones":
            this.ordenarTotalSinComisiones = !this.ordenarTotalSinComisiones;
            this.list.sort((a, b) => {
              if (
                parseFloat(this.totalSinComision(a)) >
                parseFloat(this.totalSinComision(b))
              ) {
                return vm.ordenarTotalSinComisiones ? 1 : -1;
              } else if (
                parseFloat(this.totalSinComision(a)) <
                parseFloat(this.totalSinComision(b))
              ) {
                return vm.ordenarTotalSinComisiones ? -1 : 1;
              } else {
                return 0;
              }
            });
            break;
          default:
            break;
        }
      }
    },

    emitirConsulta() {
      this.getVentasPorFormasDePago();
    },
    cambioBusiness(idBusinessData, listTpv) {
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = 0;
      this.getTpv();
      //this.getTpv();
      //this.getVentasPorFormasDePago();
    },
    cambioTpv(idTpv) {
      this.idTpv = idTpv;
      this.changeTPV();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
      this.getVentasPorFormasDePago();
    },
    openModal() {
      this.$modal.show();
    },
    getVentasPorFormasDePago() {
      // console.log("getVentasPorFormasDePago");
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: this.idTpv,
          dateto: this.dateto,
          datefrom: this.datefrom,
          formaDePago: "S",
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.list = [];
      if (this.idBusiness) {
        this.axios
          .get(
            this.$store.getters.apiUrl + "delivery/getVentasPorFormasDePago",
            config
          )
          .then(function(response) {

            if (response.data.response === false) {
              // CASO: No tiene permisos
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
              vm.respuesta = false;
            } else {
              // CASO: Tiene permisos, proceso los datos
              if (response.data.rangoMayor === true) {
                // Error en rango
                swal({
                  title: "Lo sentimos",
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                });
                vm.respuesta = false;
              } else {
                // Respuesta válida: carga los datos
                vm.list = response.data.result;
                vm.stripedata = response.data.data;
                vm.facturasRectificadas = response.data.facturasRectificadas;
                vm.respuesta = true;
              }
            }

            vm.loading.close();
            vm.reseteado = true;
            })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    changeTPV() {
      if (this.idTpv === 0) {
        this.idsTPV = [];

        for (let i = 0; i < this.listCheckBoxTpv.length; i++) {
          this.idsTPV.push(this.listCheckBoxTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }
      this.getVentasPorFormasDePago();
    },

    getTpv() {

      if (this.reseteado) {
        // console.log("getTpv");
        this.listTpv = [];
        this.reseteado = false;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function(response) {
            if (response.data.response) {
              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
              }

              vm.listCheckBoxTpv = response.data.result;

              /*let printer = {
                nameShow: vm.$t("todos"),
                id: 0,
              };
              vm.listTpv.push(printer);*/
              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }
              vm.getVentasPorFormasDePago();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
      
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();
          //vm.getVentasPorFormasDePago();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.text-progressbar {
  font-weight: bold;
  font-size: 1.3em;
  text-shadow: 1px 1px #111111;
}

a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
.sunday {
  color: rgb(128, 0, 0);
}

.fridaySaturday {
  color: rgb(0, 128, 64);
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/PedidosFormasPago.vue